import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  z-index: 4;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const UserInfoBoxWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  width: 320px;
  background-color: ${ColorSF2.skyBlue};
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.3);
  padding-bottom: 5px;
`;

export const UserInfoBox = styled.div`
  width: 320px;
  height: auto;
  background-color: ${ColorSF2.skyBlue};
`;

export const UserInfoDataMain = styled.div`
  margin: 10px 10px 5px 10px;
`;

export const UserInfoData = styled.div`
  border: none;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
  margin-bottom: 3px;
`;

export const UserInfoTitle = styled.div`
  padding: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
  font-size: 1rem;
  border: none;
`;

export const UserInfoData2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${ColorSF2.white};
`;

export const UserInfoDataPhoto = styled.div`
  margin: 10px;
  width: 60px;
  height: 60px;
`;

export const UserInfoDataName = styled.div`
  margin-left: 10px;
  font-size: 1.1rem;
  font-weight: bold;
  word-break: break-all;
`;

export const Contents = styled.div`
  min-height: 30px;
  display: flex;
  flex-direction: row;
`;

export const ContentsHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 95px;
  font-size: 12px;
  background-color: ${ColorSF2.lightGray};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  border-left: none;
`;

export const ContentsData = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  padding: 10px;
  font-size: 12px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  border-left: none;
  word-break: break-all;
`;
